module.exports = "<div class={%- classWidth %}> <i class=\"fa {%- icon %} q-fs-md q-icon-marg-left\"></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/globalHtml/iconColTemplate.html
// module id = 1135
// module chunks = 1